import {
  FormControl,
  FormHelperText,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  FormLabel,
} from "@mui/material";
import React from "react";

interface RadioWithInputProps {
  label: string;
  name: string;
  value: string;
  options: string[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  hasError?: string | false;
  disabled?: boolean;
  size?: "small" | "medium";
}

const RadioWithInput: React.FC<RadioWithInputProps> = ({
  label,
  name,
  value,
  options,
  onChange,
  required = false,
  hasError = false,
  disabled = false,
  size = "small",
}) => {
  const showError = required && !!hasError && !value;

  return (
    <FormControl
      component="fieldset"
      error={showError}
      size={size}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <Typography
        component="label"
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: "180px",
        }}
      >
        <FormLabel required={required}>{label}</FormLabel>
      </Typography>

      <RadioGroup row name={name} value={value} onChange={onChange}>
        {options.map((option, idx) => (
          <FormControlLabel
            key={idx}
            value={option}
            control={
              <Radio
                size={size}
                disabled={disabled}
                sx={{
                  color: showError ? "error.main" : undefined,
                  "&.Mui-checked": {
                    color: showError ? "error.main" : undefined,
                  },
                }}
              />
            }
            label={option}
            disabled={disabled}
            sx={{
              marginRight: 2,
              "& .MuiFormControlLabel-label": {
                color: showError ? "error.main" : "inherit",
              },
            }}
          />
        ))}
      </RadioGroup>

      <FormHelperText sx={{ marginLeft: "165px" }}>{hasError}</FormHelperText>
    </FormControl>
  );
};

export default RadioWithInput;
